import { render, staticRenderFns } from "./follow-up-status.vue?vue&type=template&id=7c8baa87&scoped=true"
import script from "./follow-up-status.vue?vue&type=script&lang=js"
export * from "./follow-up-status.vue?vue&type=script&lang=js"
import style0 from "./follow-up-status.vue?vue&type=style&index=0&id=7c8baa87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8baa87",
  null
  
)

export default component.exports